import ProductDetailSideMenu from './productDetailSideMenu'

export default ProductDetailSideMenu
